export const changeCameraOnMap = (payload) => {
    return {
        type: "CHANGE_CAMERA_ON_MAP",
        payload
    }
};

export const setMaximizeMap = (payload) => {
    return {
        type: "SET_MAXIMIZE_MAP",
        payload
    }
};